<template>
  <div id="app" :class="[dark ? 'dark-mode-page' : '']">
    <LoginComponent v-if="!authenticated" />

    <div v-else>
      <Mobile />
      <div class="d-flex flex-column flex-root">
        <div class="d-flex flex-row flex-column-fluid page">
          <multipane
            :class="resizer"
            layout="vertical"
            ref="multipane"
            @mousedown.stop
          >
            <MenuComponent
              @locatePlaceMarker="locatePlaceMarker($event)"
              @loadMarkerCircuit="loadMarkerCircuit($event)"
              @loadMarkerSubstation="loadMarkerSubstation($event)"
              @loadTech="loadTech($event)"
              @loadAllTechs="loadAllTechs($event)"
              @loadMarkerSector="loadMarkerSector($event)"
              @loadWarningManaged="loadWarningManaged($event)"
              @loadWarningManagedCircuit="loadWarningManagedCircuit($event)"
              @loadInformationOT="loadInformationOT"
              @loadKML="loadKML"
              @brigadeDate="brigadeData = $event"
              @clearTreeCheckbox="clearTreeCheckbox()"
              ref="menuComponent"
            />
            <multipane-resizer></multipane-resizer>
            <div
              class="d-flex flex-column flex-row-fluid"
              id="kt_wrapper"
              style="height: 100vh; overflow-y: hidden"
            >
              <Header @loadCor="loadCor($event)" />
              <div
                class="content d-flex flex-column flex-column-fluid"
                id="kt_content"
                :style="ktContentHeight"
              >
                <div class="container-fluid content-box-vue">
                  <transition name="fade" mode="out-in">
                    <router-view
                      @loadCor="loadCor($event)"
                      @loadMenu="loadMenu($event)"
                      :brigadeData="brigadeData"
                      ref="routerView"
                    />
                  </transition>
                </div>
              </div>
            </div>
          </multipane>
        </div>
      </div>
      <InformacionAviso ref="INFO" />
      <InformacionOT ref="INFOOT" />
      <UserPanel />
      <NotificationsStopBrigade v-if="can('notification-brigade-inactive')"/>
    </div>

  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import { Multipane, MultipaneResizer } from "vue-multipane";

import  can from '@/permission';
import LoginComponent from "@/components/auth/Login.vue";

import Header from "@/components/helpers/Header.vue";
import Mobile from "@/components/helpers/headerMobile.vue";
import MenuComponent from "@/components/helpers/menuComponent.vue";

import UserPanel from "@/components/helpers/quickUser.vue";
import InformacionAviso from "@/components/helpers/modals/informacionAviso.vue";
import InformacionOT from "@/components/helpers/modals/informacionOT.vue";
import NotificationsStopBrigade from '@/components/notifications/NotificationsStopBrigade.vue';

export default {
  components: {
    LoginComponent,
    Header,
    Mobile,
    MenuComponent,
    UserPanel,
    Multipane,
    MultipaneResizer,
    InformacionAviso,
    InformacionOT,
    NotificationsStopBrigade,
  },
  mounted() {
    // console.log(this.$root.$children[0].$children[1].$children[0]);
    console.log(
      "%c Bienvenido a SIPREM CLD!!",
      `font-weight: bold; 
        font-size: 32px; `
    );
    if (sessionStorage.sectores) {
      this.changeCor(JSON.parse(sessionStorage.sectores));
    }
    if (this.$route.path == "/works") this.ktContentHeight = "";
    else this.ktContentHeight = "height: 80vh;";
  },
  data() {
    return {
      ktContentHeight: "height: 80vh;",
      resizer: "custom-resizer",
      dep: null,
      newMarker: null,
      case: null,
      municipality: null,
      refreshPage: false,
      dir_ref: null,
      load: false,
      currentModel: null,
      ot: null,
      kml: [],
      brigadeData: {},

      keyTechnical: 0,
    };
  },
  watch: {
    $route: {
      handler: function (newRouteValue) {
        if (newRouteValue.path == "/works") this.ktContentHeight = "";
        else this.ktContentHeight = "height: 80vh;";
      },
      deep: true,
    },
    dark: {
      immediate: true,
      handler(isDark) {
        this.loadTheme(isDark);
        isDark 
          ? document.body.classList.add("dark-mode-page") 
          : document.body.classList.remove("dark-mode-page")
       
      }
    }
  },
  computed: {
    ...mapGetters({
      authenticated: "auth/authenticated",
      user: "auth/user",
      warnings: "location/getWarning",
      getIds: "location/getIds",
      getIdx: "warningsOT/getIdx",
      getIdCert: "warningsOT/getIdCert",
      dark: "mode/getTheme",
    }),
  },
  methods: {
    ...mapActions({
      changeIds: "location/changeIds",
      loadAllWarning: "location/loadCircuit",
      // changeTechId: "technical/changeTechIds",
      setIdOT: "warningsOT/setIdOT",
      removeWarningCircuit: "location/removeWarningCircuit",
      setStaticId: "location/setStaticId",
      setIdCert: "warningsOT/setIdCert",
      setIdxAll: "warningsOT/setIdxAll",
      insertOrUpdate: "warningsOT/insertOrUpdate",
      changeCor: "auth/zoneWork",
      addNewSelectTech: "technical/addNewSelectTech",
      removeSelectTech: "technical/removeSelectTech",
    }),
    can: can,
    loadKML(data) {
      this.kml = data;
    },
    locatePlaceMarker(values) {
      let aux = values;
      values = values.id_aviso == undefined ? null : values;
      if (values != null) {
        this.newMarker = values.id_aviso;
        this.case = values.slug;
        this.dir_ref = `${values.dir_suscriptor} - ${values.dir_suscriptor}`;
        if (values.slug == "not_ubicated_second") {
          this.municipality = values.selected ? `${values.municipio}` : null;
          if (values.isUpdateCoordinates && values.isUpdateCoordinates == "Actualizar coordenadas") {
            this.refreshPage = true;
          } else {
            this.refreshPage = false;
          }
        }
        if (values.slug == "assign_ot") {
          this.changeIds(values);
        }
      } else {
        this.newMarker = null;
        this.municipality = null;
      }

      if (aux.alternative != undefined && aux.alternative == "assign_ot") {
        this.case = aux.value.slug;
        this.changeIds(aux.value);
      }
    },
    loadMarkerCircuit(event) {
      if (event != null) {
        this.case = event.slug;
        let ids = [];
        event.children.map((m) => {
          ids.push(m.id_aviso);
        });
        if (event.selected) {
          this.newMarker = ids;
          this.loadAllWarning(this.newMarker);
        } else {
          this.removeWarningCircuit(this.newMarker);
          this.newMarker = this.getIds;
        }
      } else {
        this.loadAllWarning(null);
        this.newMarker = null;
      }
    },
    loadMarkerSubstation(event) {
      if (event != null) {
        this.case = event.slug;
        let ids = [];
        event.children.map((m) => {
          m.children.map((x) => {
            ids.push(x.id_aviso);
          });
        });
        this.newMarker = ids;

        if (event.selected) {
          this.loadAllWarning(this.newMarker);
        } else {
          this.removeWarningCircuit(this.newMarker);
          this.newMarker = this.getIds;
        }
      } else {
        this.loadAllWarning(null);
        this.newMarker = null;
      }
    },
    loadMarkerSector(event) {
      // console.log(event.slug);
      if (event != null) {
        this.case = event.slug;
        let ids = [];
        event.children.map((m) => {
          m.children.map((s) => {
            s.children.map((x) => {
              ids.push(x.id_aviso);
            });
          });
        });
        this.newMarker = ids;

        if (event.selected) {
          this.loadAllWarning(this.newMarker);
        } else {
          this.removeWarningCircuit(this.newMarker);
          this.newMarker = this.getIds;
        }
      } else {
        this.loadAllWarning(null);
        this.newMarker = null;
      }
    },
    loadTech(event) {
      if (event.selected) {
        this.case = event.slug;
        this.newMarker = event.usuario;
        this.addNewSelectTech(event.usuario);
      } else {
        this.newMarker = `technicalOff,${this.keyTechnical++}`;
        this.removeSelectTech(event.usuario);
      }
      // this.changeTechId(event);
    },
    loadAllTechs(event) {
      if (event.selected) {
        this.case = event.slug;
        const usersBrigades = event.children.map((brigade)=>{
          this.addNewSelectTech(brigade.usuario);
          return brigade.usuario;
        }).join("|");
        this.newMarker = usersBrigades;
      } else {
        event.children.forEach(brigade => {
          this.removeSelectTech(brigade.usuario);
        });
        this.newMarker = "technicalOff";
      }
    },
    loadMenu(values) {
      if (values.load == 1) {
        this.newMarker = null;
        this.$refs.menuComponent.treeMenu(this.$refs.menuComponent.data);
      }
    },
    loadCor(values) {
      this.$refs.menuComponent.setCor(values);
      this.dep = values;
    },
    departmentFromHome(values) {
      this.$refs.routerView.setCor(values);
      this.dep = values;
    },
    loadWarningManaged(event) {
      if (event != null) {
        this.case = event.slug;
        if (event.slug == "aviso_gestionado") {
          this.changeIds(event);
          this.newMarker = this.getIds;
        }
      } else {
        this.case = null;
        this.newMarker = null;
      }
    },
    loadWarningManagedCircuit(event) {
      if (event != null) {
        this.case = event.slug;
        let ids = [];
        event.children.map((m) => {
          if (this.case == "subestacion_aviso_gestionado") {
            m.children.map((x) => {
              ids.push(x.id_aviso);
            });
          } else if (this.case == "circuito_aviso_gestionado")
            ids.push(m.id_aviso);
        });
        if (event.selected) {
          this.newMarker = ids;
          this.loadAllWarning(this.newMarker);
        } else {
          this.removeWarningCircuit(this.newMarker);
          this.newMarker = this.getIds;
        }
      } else {
        this.loadAllWarning(null);
        this.newMarker = null;
      }
    },
    loadInformationOT(event) {
      if (event.slug == "CIRCUITO_OT") {
        if (event) {
          this.case = event.slug;
          event.children.map((el) => {
            this.setIdOT(el);
          });
          this.newMarker = this.getIdx;
        }
      } else if (event.slug == "SUBESTACION_OT") {
        if (event) {
          this.case = event.slug;
          event.children.map((el) => {
            el.children.map((av) => {
              this.setIdOT(av);
            });
          });
          this.newMarker = this.getIdx;
        }
      } else {
        this.setIdOT(event);
        this.currentModel = event;
        if (event.selected) {
          this.case = event.slug;
          if (event.slug == "OTTECH") {
            this.case == "ot_managed_tree";
          }
          this.newMarker = this.getIdx;
        }
      }
    },
    clearTreeCheckbox(){
      this.removeWarningCircuit(this.newMarker);
      this.newMarker = this.getIds;
    },
    loadTheme(isDark) {
    // Remover tema anterior
      const existingLink = document.getElementById('devextreme-theme');
      if (existingLink) {
        existingLink.remove();
      }

      // Crear nuevo link
      const link = document.createElement('link');
      link.id = 'devextreme-theme';
      link.rel = 'stylesheet';
      link.href = isDark 
        ? '/assets/css/dx.dark.compact.css'
        : '/assets/css/dx.light.compact.css';
      
      // Forzar recarga
      link.href += `?v=${Date.now()}`;
      document.head.appendChild(link);
    },
  },
  name: "App",
};
</script>
<style>
.component-fade-enter-active,
.component-fade-leave-active {
  transition: opacity 0.3s ease;
}
.component-fade-enter,
.component-fade-leave-to {
  opacity: 0;
}
@media (min-width: 792px) {
  .content {
    padding: 5px 0 !important;
  }
  .content-box-vue {
    padding: 12px 5px !important;
    overflow-x: hidden;
  }
}
@media (max-width: 991.98px) {
  .aside {
    left: 0 !important;
  }
}

#kt_aside {
  position: relative;
  max-width: 45%;
  min-width: 25%;
}
/* #kt_content{
    padding-top: 60px !important;
  } */
/* .multipane > div{
    z-index: 100 !important;
  } */
.layout-v > .multipane-resizer {
  width: 8px !important;
  height: 100% !important;
  margin-left: 0px !important;
  left: 0px !important;
  cursor: col-resize;
}
.multipane {
  width: 100%;
}
.custom-resizer > .multipane-resizer {
  margin: 0;
  left: 0;
  position: relative;
}
.custom-resizer > .multipane-resizer::before {
  display: block;
  content: "";
  width: 3px;
  height: 40px;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -20px;
  margin-left: 0 !important;
  background-color: rgb(175, 175, 175);
}
.custom-resizer > .multipane-resizer:hover::before {
  /* border-color: rgb(65, 64, 64); */
  background-color: rgb(94, 94, 94);
}
body {
  overflow-y: hidden;
}
</style>
